import React from "react";
import { default as moment } from "moment";

import { IDataFragment } from "core/components/FragmentProvider";
import Label from "core/components/label/Label";
import styled from "styled-components";
import { TextInputView } from "common/views/textInput/TextInput.view";
import { ICESelfReportFragmetProps } from "./CESelfReportForm.panel";
import RichTextWidgdet from "common/form/widgets/richText/RichTextWidget";
import Query from "core/api/QueryComponent";
import { CreditEntryDescription, CreditType } from "panels/subscriptions/entities/CreditEntry";
import { stateToHTML } from "draft-js-export-html";
import { ContentState, convertFromRaw } from "draft-js";
import isJsonString from "common/fragments/CheckJson";
import TypographyView from "common/views/typographyView/Typography.view";
import { BlockView } from "common/views/block/BlockView.view";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import Loading from "common/fragments/Loading";

const StyledDiv = styled.div`
	 {
		display: flex;
		justify-content: flex-start;
		padding: 0.5em;
		width: 50%;
		flex-flow: column wrap;
		margin-bottom: 12px
		& > input {
			height:40px;
		}
		// text-align: center;
		// & > span {
		// 	flex: 2;
		// }
		// & > div {
		// 	flex: 1;
		// }
	}
`;

export const name: IDataFragment<ICESelfReportFragmetProps> = {
	name: "name",
	label: {},
	component: ({ onChange, entry }) => {
		return (
			<React.Fragment>
				<StyledDiv>
				<TypographyView viewKey="name.title"  >
					<Label k="Label.CE.name" v="Name" />
				</TypographyView>
					<TextInputView
						viewKey="CE.name"
						placeholder="Name"
						value={entry.name}
						onChange={(value: string) => onChange("name", value)}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const startDate: IDataFragment<ICESelfReportFragmetProps> = {
	name: "startDate",
	label: {},
	component: ({ onChange, entry }) => {
		let attr = {};
		attr["max"] = (() => {
			let d = new Date();
			d.setFullYear(d.getFullYear() + 5);
			return moment(d).format("YYYY-MM-DD");
		})();

		return (
			<React.Fragment>
				<StyledDiv>
					<TypographyView viewKey="startDate.title" >
						<Label k={"startDate"} v={"Start Date"} />
					</TypographyView>
					<TextInputView
						viewKey="CE.startDate"
						type="date"
						placeholder="Start Date"
						value={entry.startDate}
						onChange={(value: string) =>
							onChange("startDate", value)
						}
						htmlAttributes={attr}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const endDate: IDataFragment<ICESelfReportFragmetProps> = {
	name: "endDate",
	label: {},
	component: ({ onChange, entry }) => {
		let attr = {};

		if (!entry["startDate"]) attr["disabled"] = true;
		else {
			attr["max"] = (() => {
				let d = new Date();
				d.setFullYear(d.getFullYear() + 5);
				return moment(d).format("YYYY-MM-DD");
			})();

			attr["min"] = (() => {
				let d = entry["startDate"];
				return moment(d).format("YYYY-MM-DD");
			})();
		}

		return (
			<React.Fragment>
				<StyledDiv>
				<TypographyView viewKey="endDate.title"  >
					<Label k={"endDate"} v={"End Date"} />
				</TypographyView>
					<TextInputView
						viewKey="CE.endDate"
						type="date"
						placeholder="End Date"
						value={entry.endDate}
						onChange={(value: string) => onChange("endDate", value)}
						htmlAttributes={attr}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const creditYear: IDataFragment<ICESelfReportFragmetProps> = {
	name: "Credit Year",
	label: {},
	component: ({ onChange, entry }) => {
		const yearOptions = [];
		const currentYear = new Date().getFullYear();
		for (let i = 0; i < 25; i++) {
			const year = currentYear - i;
			yearOptions.push({ label: year.toString(), value: year.toString() });
		}

		return (
			<React.Fragment>
				<StyledDiv>
					<BlockView viewKey="dropdown">
						<div style={{ display: 'flex' }}>
							<TypographyView viewKey="credityear.title" style={{ marginTop: '-4px' }}>
						<Label k={"credityear"} v={"Credit year"} />
					</TypographyView>
							<DropdownSelect
								buttonProps={{
									minimal: true,
									small: true,
								}}
								options={yearOptions}
								value={entry.year || currentYear.toString()}
								onChange={(value: string) => onChange("year", value)}
							/>
						</div>
					</BlockView>
				</StyledDiv>
			</React.Fragment>
		);
	}
};

export const description: IDataFragment<ICESelfReportFragmetProps> = {
	name: "description",
	label: {},
	component: ({ onChange, entry }) => {
		if (entry.subscriptionId) {
			return (
				<Query.One entity={CreditEntryDescription} args={{ subscriptionId: entry.subscriptionId, includeDescription: true }}>
					{({ data, loading }) => {
						if (loading) {
							return <Loading key="loading" />;
						}
						if (!data) {
							return;
						}
						const desc = data as CreditEntryDescription;
						return (
							<StyledDiv style={{ width: "100%" }}>
								<TypographyView viewKey="description.title"  >
									<Label k="Label.CE.description" v="Description" />
								</TypographyView>
								<RichTextWidgdet
									value={desc.description}
									onChange={data => {
										const isRaw = isJsonString(data);
										if (isRaw) {
											let raw = convertFromRaw(JSON.parse(data));
											onChange("description", stateToHTML(raw));
											return;
										}

										onChange("description", data);

									}}
								/>
							</StyledDiv>)
					}}
				</Query.One>
			);
		} else {
			return (
				<StyledDiv style={{ width: "100%" }}>
					<TypographyView viewKey="description.title"  >
						<Label k="Label.CE.description" v="Description" />
					</TypographyView>
					<RichTextWidgdet
						value={entry.description}
						onChange={data => {
							const isRaw = isJsonString(data);
							if (isRaw) {
								let raw = convertFromRaw(JSON.parse(data));
								onChange("description", stateToHTML(raw));
								return;
							}

							onChange("description", data);

						}}
						/>
				</StyledDiv>
			);
		}
	}
};

export const credits: IDataFragment<ICESelfReportFragmetProps> = {
    name: "Credits",
    label: {},
    component: ({ onChange, entry, config }) => {
        let attr = {};
        attr["step"] = config.creditStep || 1;
		if (entry.subscriptionId) {
		// Fetch credits using Query.Many
		return (
			<Query.Many entity={CreditType} args={{ id: 0 }}>
				{({ data, forceRefresh }) => {
					let mergedCredits;

					// Edit mode - merge entry.credits with query response
					if (entry.subscriptionId) {
						// Convert entry.credits to array if it exists
						const entryCreditsArray = entry.credits
							? (Array.isArray(entry.credits)
								? entry.credits
								: Object.values(entry.credits))
							: [];

						// Create a map of entry credits by id for quick lookup
						const entryCreditsMap = new Map<any, any>(
							entryCreditsArray.map((credit: any) => [credit.id, credit] as [any, any])
						);

						// Merge credits from query response with entry.credits
						mergedCredits = data && data.map(credit => {
							const entryCredit = entryCreditsMap.get(credit.id);
							return {
								id: credit.id,
								name: credit.name,
								value: entryCredit && entryCredit.value || ""
							};
						});
					} else {
						// Create mode - use query response and check entry.credits for values
						const entryCreditsArray = entry.credits
							? (Array.isArray(entry.credits)
								? entry.credits
								: Object.values(entry.credits))
							: [];

						const entryCreditsMap = new Map<any, any>(
							entryCreditsArray.map((credit: any) => [credit.id, credit] as [any, any])
						);

						mergedCredits = data && data.map(credit => {
							const entryCredit = entryCreditsMap.get(credit.id);
							return {
								id: credit.id,
								name: credit.name,
								value: entryCredit && entryCredit.value || ""
							};
						});
					}

					const renderedCredits = mergedCredits && mergedCredits.map((credit: any) => {
						return (
							<StyledDiv key={credit.id}>
								<TypographyView viewKey="credits.title">
									<Label
										k={`Label.CE.${credit.name}`}
										v={credit.name}
									/>
								</TypographyView>
								<TextInputView
									viewKey={`CE.${credit.name}`}
									type="number"
									placeholder={credit.name}
									value={credit.value}
									htmlAttributes={attr}
									onChange={value => {
										// Get current credits array from entry
										const currentCredits = entry.credits
											? (Array.isArray(entry.credits) ? entry.credits : Object.values(entry.credits))
											: [];

										// Check if credit already exists in current credits
										const existingIndex = currentCredits.findIndex((c: any) => c.id === credit.id);

										let updatedCredits;
										if (existingIndex >= 0) {
											// Update existing credit
											updatedCredits = currentCredits.map((c: any) =>
												c.id === credit.id
													? { id: credit.id, name: credit.name, value: value }
													: c
											);
										} else {
											// Add new credit
											updatedCredits = [...currentCredits, { id: credit.id, name: credit.name, value: value }];
										}

										onChange("credits", updatedCredits);
									}}
								/>
							</StyledDiv>
						);
					});
					return <React.Fragment>{renderedCredits}</React.Fragment>;
				}}
			</Query.Many>
		);
		} else {
			return (
				<Query.Many entity={CreditType} args={{ id: 0 }}>
					{({ data, forceRefresh }) => {
						const credits = [];
						data &&
							data.map(credit => {
								credits.push(
									<StyledDiv>
										<TypographyView viewKey="credits.title" >
											<Label
												k={`Label.CE.${credit.name}`}
												v={credit.name}
											/>
										</TypographyView>
										<TextInputView
											viewKey={`CE.${credit.name}`}
											type="number"
											placeholder={credit.name}
											value={entry[credit.name]}
											htmlAttributes={attr}
											onChange={value => {
												let key = credit.id;
												let credits = { ...entry.credits }
												credits[key] = {
													id: credit.id,
													name: credit.name,
													value: value,
												}

												onChange("credits", credits);
											}
											}
										/>
									</StyledDiv>
								);
							});
						return <React.Fragment>{credits}</React.Fragment>;
					}}
				</Query.Many>
			)
		}
    }
};

export const uploadCertificate: IDataFragment<ICESelfReportFragmetProps> = {
	name: "Upload Certificate",
	label: {},
	component: ({ onChange, entry }) => {
		return (
			<React.Fragment>
				<StyledDiv>
					<TypographyView viewKey="upload.certificate.title" >
						<Label
							k="Label.CE.uploadCertificate"
							v="Upload Certificate"
						/>
					</TypographyView>
					<TextInputView
						viewKey="CE.uploadCertificate"
						type="file"
						placeholder="uploadCertificate"
						value={entry.uploadCertificate}
						onChange={value => {
							onChange("certificate", value[0]);
						}}
					/>
				</StyledDiv>
			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./src/panels/addExternalCredit/displayFragments.tsx